import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISetUnqualified = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable &&
        <Box className="mtska-kpi-set">
            <KPI
                title="AreaSources"
                icon="faGauge"
                dataProviderName={'statisticsviews/item/count/commercials/areaSource'}
                filters={filterModel}
            />
            <KPI
                title="Lead Goal"
                icon="faGauge"
                dataProviderName={'statisticsviews/item/sum/commercials/areaSource/leadGoal'}
                filters={filterModel}
            />
        </Box>
    )
}

export default KPISetUnqualified;